import React, { FC, useEffect, useState } from 'react';
import { RootState } from 'redux/store';
import ContentBlock from 'components/ContentBlock/Index';
import Preferences from 'components/shared/Preferences/Index';
import CompetencyScores from 'components/shared/competencyScores/Index';
import { ITranslate } from 'core/interface/translate';

import Popup from 'components/shared/Popups/Popup/Index';
import PreferencesPopup from 'components/shared/Popups/Preferences/Index';
import { CompetencieService } from 'services/competencies/competencies';
import { ICompetencyScoresItems } from 'core/interface/competencyScores';
import { useSelector } from 'react-redux';
import { IPreferencesItem } from 'core/interface/preferences';
import { setPreferenceValues } from './candidatePreferences';

import './Index.scss';

const CompetencyPreferencesTab: FC<ITranslate> | any = ({
  t,
  fromGuest
}: any): JSX.Element => {
  const { candidates } = useSelector((state: RootState) => state.candidates);
  const user = useSelector((state: RootState) => state.user).user;
  const [showPreference, setShowPreference] = useState<boolean>(false);
  const [preferenceItems, setPreferenceItems] = useState<IPreferencesItem[]>(
    []
  );
  useEffect(() => {
    getCompetencies();
  }, []);

  useEffect(() => {
    setPreferenceItems(setPreferenceValues(candidates));
  }, [candidates]);

  const editPreference = (): void => {
    setShowPreference(true);
  };
  const handleClose = (): void => {
    setShowPreference(false);
  };

  const getCompetencies = (): void => {
    CompetencieService.getCompetencies();
  };

  return (
    <div className="tab">
      <ContentBlock
        title={t('Preferences')}
        className="tab__pref"
        onActionClick={editPreference}
        showButton={fromGuest ? false : true}
      >
        <Preferences preferences={preferenceItems} />
      </ContentBlock>
      <ContentBlock
        className="tab__comp"
        title={t('Competency scores')}
        showButton={false}
      >
        {user?.company && candidates ? (
          <CompetencyScores candidateUserId={candidates.user} />
        ) : (
          <CompetencyScores />
        )}
      </ContentBlock>
      {showPreference && (
        <Popup title={t('Preferences')} onClose={handleClose}>
          <PreferencesPopup handleClose={handleClose} t={t} />
        </Popup>
      )}
    </div>
  );
};

export default CompetencyPreferencesTab;
